<template>
  <div class="outer-box max-w-xl">
    <h4>Sync Location Twilio Creds - ISV locations only</h4>

    <b-alert show variant="danger" class="text-left m-3">
      <b>Action to be taken based on response <br />received after hitting sync button</b>
      <br />
      1. If account is suspended, <br />please reach out to twilio support for activation
      <br />
      2. If token is already synced and we are still <br />seeing auth error on phone number page,
      reach out to dev team
      <br />
      3.On successfully cred sync, see if auth error is gone.<br />If error is still there, reach
      out to dev team
    </b-alert>
    <div class="inner-box" style="text-align: left; width: 500px">
      <input class="hl_input--wrap" type="text" placeholder="Location ID" v-model="locationId" />
      <button class="btn btn-primary mt-4" @click="fetchISVInfoForLocation">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Sync Creds</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService } from "@/services";

export default {
  data() {
    return {
      locationId: "",
      processing: false,
      response: null,
    };
  },
  methods: {
    fetchISVInfoForLocation() {
      this.processing = true;
      SaasService.syncLocationTwilioCreds(this.locationId)
        .then((response) => {
          this.response = response.data;
        })
        .catch((error) => {
          this.response = error.response.data;
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>

<style></style>
